





















































// vendor
import { defineComponent, ref, computed, PropType } from "@vue/composition-api";
import Draggable from "vuedraggable";
// project
import { move as arrMove } from "@/utils/array";
import { pascalToSentenceCase } from "@/utils/text";
// local
import * as Factories from "../ts/factories";
import * as ItemTypes from "../ts/ItemTypes";
import AddItemButton from "./add-item-button.vue";
import SectionSettings from "./section-settings.vue";
import FormItem from "./edit-form-item.vue";
import { FormSection } from "../ts/types";

const dragOptions = {
	animation: 200,
	disabled: false,
	ghostClass: "ghost",
	forceFallback: true,
};

type SectionInfo  = {
	index:number,
	count:number
}

export default defineComponent({

	props:{
		section:{
			type:Object as PropType<FormSection>,
			required:true
		},
		allowDrag:{
			type:Boolean
		},
		info:{
			type:Object as PropType<SectionInfo>,
			required:true
		}
	},
	components: {
		AddItemButton,
		FormItem,
		Draggable,
		SectionSettings
	},
	setup(props){


		const items = computed(() => {
			return props.section.items.map((it) => {
				let metadata = (ItemTypes as any)[it.type];
				return {
					icon: metadata ? metadata.icon : "",
					type: metadata.id,
					data: it,
					typeLabel: pascalToSentenceCase(it.type)
				}
			});
		});

		const add = (type:string) => {
			const item = Factories.createFormItem(type);
			props.section.items.push(item);
		};

		const deleteAtIndex = (i:number) => {
			props.section.items.splice(i, 1);
		};

		return {
			items,
			dragOptions,
			add,
			deleteAtIndex
		};


	}

});




